<app-crear-editar
  [title]="modoEdicion ? 'Editar recorrido dinámico' : 'Planificador de rutas'"
  icono="alt_route"
>
  <div class="planificador-layout">
    <!-- Mapa -->
    <app-content-card title="Mapa" icon="map" class="mapa-col">
      <div class="mapa-wrapper">
        <div class="autocomplete-overlay">
          <div class="autocomplete-row">
            <input
              #inputDireccion
              type="text"
              [(ngModel)]="direccionBuscada"
              placeholder="Buscar dirección..."
              class="direccion-input"
              (focus)="onInputFocus()"
              (blur)="onInputBlur()"
            />
          </div>
          @if (predicciones?.length && showSuggestions) {
            <div class="suggestions">
              @for (pred of predicciones; track pred) {
                <div
                  (mousedown)="seleccionarPrediccion(pred)"
                  (keydown.enter)="seleccionarPrediccion(pred)"
                  class="suggestion-item irx-clickeable"
                  role="button"
                  tabindex="0"
                >
                  {{ pred }}
                </div>
              }
            </div>
          }
          @if (buscandoDireccion) {
            <div class="loading">Buscando...</div>
          }
        </div>

        <div #mapContainer class="map-content"></div>
      </div>
      <small class="hint">
        Hacé click en el mapa para agregar puntos, o buscalos por dirección.
      </small>
    </app-content-card>

    <!-- Puntos y cálculo -->
    <app-content-card
      title="Puntos del recorrido"
      icon="place"
      class="lista-col"
    >
      <section class="planificador-panel">
        <div class="agregar-zona">
          <ng-select
            [items]="zonas"
            [(ngModel)]="zonaSeleccionada"
            (ngModelChange)="agregarZona()"
            bindLabel="identificacion"
            placeholder="Agregar zona ya declarada..."
            [notFoundText]="'No hay zonas declaradas'"
            [searchable]="true"
            appendTo="body"
          ></ng-select>
        </div>

        @if (puntos.length === 0) {
          <p class="sin-puntos">Todavía no agregaste puntos.</p>
        } @else {
          <div class="lista-puntos">
            @for (punto of puntos; track punto; let i = $index) {
              <div class="punto-item">
                <span class="punto-numero">{{ i + 1 }}</span>
                <span class="punto-texto">
                  {{ punto.direccion ?? formatCoordenadas(punto.coordenadas) }}
                </span>
                <app-button
                  matType="mat-mini-fab"
                  color="warn"
                  icon="delete"
                  tooltip="Quitar punto"
                  (click)="eliminarPunto(punto)"
                ></app-button>
              </div>
            }
          </div>
        }

        <mat-divider></mat-divider>

        <section class="inicio-fin">
          <mat-slide-toggle [(ngModel)]="definirInicioFin">
            Definir punto de inicio y fin
          </mat-slide-toggle>

          @if (definirInicioFin) {
            <div class="inicio-fin-selects">
              <ng-select
                [items]="puntos"
                [(ngModel)]="puntoInicio"
                placeholder="Punto de inicio"
                [clearable]="true"
                appendTo="body"
              >
                <ng-template ng-label-tmp let-item="item">
                  #{{ numeroDePunto(item) }} —
                  {{ item.direccion ?? formatCoordenadas(item.coordenadas) }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  #{{ numeroDePunto(item) }} —
                  {{ item.direccion ?? formatCoordenadas(item.coordenadas) }}
                </ng-template>
              </ng-select>
              <ng-select
                [items]="puntos"
                [(ngModel)]="puntoFin"
                placeholder="Punto de fin"
                [clearable]="true"
                appendTo="body"
              >
                <ng-template ng-label-tmp let-item="item">
                  #{{ numeroDePunto(item) }} —
                  {{ item.direccion ?? formatCoordenadas(item.coordenadas) }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  #{{ numeroDePunto(item) }} —
                  {{ item.direccion ?? formatCoordenadas(item.coordenadas) }}
                </ng-template>
              </ng-select>
            </div>
          }
        </section>

        @if (resultado) {
          <div class="resultado">
            <div class="metrica">
              <span class="metrica-valor">
                {{ resultado.distanciaKm | number: '1.1-1' }}
                <em>km</em>
              </span>
              <span class="metrica-label">Distancia</span>
            </div>
            <div class="metrica">
              <span class="metrica-valor">
                {{ resultado.duracionMin | number: '1.0-0' }}
                <em>min</em>
              </span>
              <span class="metrica-label">Duración estimada</span>
            </div>
          </div>
        }

        <div class="acciones">
          <app-button
            matType="mat-raised-button"
            color="primary"
            icon="alt_route"
            text="Calcular mejor ruta"
            [disabled]="!puedeCalcular"
            [loading]="calculando"
            (click)="calcularMejorRuta()"
          ></app-button>
          <app-button
            matType="mat-raised-button"
            color="neutral"
            icon="clear"
            text="Limpiar todo"
            [disabled]="puntos.length === 0"
            (click)="limpiarTodo()"
          ></app-button>
        </div>

        @if (resultado) {
          <mat-divider></mat-divider>

          <section class="guardar-asignar">
            <p class="subtitulo">
              {{
                modoEdicion
                  ? 'Guardar cambios'
                  : 'Guardar y asignar a un vehículo'
              }}
            </p>

            <mat-form-field style="width: 100%">
              <mat-label>Nombre del recorrido</mat-label>
              <input matInput [(ngModel)]="nombreRecorrido" />
            </mat-form-field>

            <ng-select
              [items]="vehiculos"
              [(ngModel)]="vehiculoSeleccionado"
              bindLabel="identificacion"
              placeholder="Vehículo"
              [notFoundText]="'No hay vehículos'"
              [searchable]="true"
              appendTo="body"
            ></ng-select>

            <app-date-picker
              mode="datetimerange"
              label="Ventana para hacer el recorrido"
              [(ngModel)]="ventana"
            ></app-date-picker>

            <mat-form-field style="width: 100%" subscriptSizing="dynamic">
              <mat-label>Radio de tolerancia por punto</mat-label>
              <input
                matInput
                type="number"
                min="10"
                [(ngModel)]="radioToleranciaMetros"
                (ngModelChange)="actualizarCirculosTolerancia()"
              />
              <span matTextSuffix>m</span>
              <mat-hint>
                Distancia máxima al punto para contar como "visitado"
              </mat-hint>
            </mat-form-field>
          </section>
        }
      </section>
    </app-content-card>
  </div>

  <ng-container actions>
    <app-button
      matType="mat-fab extended"
      color="neutral"
      icon="close"
      text="Cancelar"
      (click)="helper.volver()"
    ></app-button>
    <!-- Se habilita una vez calculada la ruta y completados los datos -->
    <app-button
      matType="mat-fab extended"
      color="primary"
      icon="save"
      [text]="modoEdicion ? 'Guardar cambios' : 'Guardar y asignar'"
      [disabled]="!puedeGuardar"
      [loading]="guardando"
      (click)="guardarYAsignar()"
    ></app-button>
  </ng-container>
</app-crear-editar>
